import LogRocket from "logrocket";
import * as logs from '@/plugins/logs.js'

export const init = () => {
	if (logs.isDev()) {
		return logs.log({
			msg: 'Development Environment',
			// arr: [
			// 	'This is a Development Environment',
			// 	process.env.VUE_APP_API_ENV,
			// 	'isDev() passed',
			// 	'LogRocket will not get any information'
			// ]
		});
	}

	logs.log({
		msg: `Current Environment`,
		obj: process.env.VUE_APP_API_ENV
	})
	
	LogRocket.init("wrlhlc/efundraising", {
		dom: {
			inputSanitizer: true,
		},
		network: {
			requestSanitizer: request => {
				// scrub header value from request
				if (request.headers['Authorization']) {
					request.headers['Authorization'] = '';
				}

				// Sanitize request url with token
				request.url = request.url.replace(/token=([^&]*)/, 'token=**redacted**');

				// make sure you return the modified request
				return request;
			},
			responseSanitizer: response => {
				// scrub accessToken && refreshToken value if they exist in the response body
				if (response.body) {
					let body = JSON.parse(response.body)
					
					if (body.accessToken) body.accessToken = null;
					if (body.refreshToken) body.refreshToken = null;
					
					if (body.recentActivity) body.recentActivity = null;
					if (body.invoices) body.invoices = null;
					if (body.invoices) body.invoices = null;

					if (body.clientToken) body.clientToken = null;
					if (body.accountNumber) body.accountNumber = null;
					if (body.routingNumber) body.routingNumber = null;
					if (body.billingAddress) body.billingAddress = null;
					if (body.billingCity) body.billingCity = null;
					if (body.billingState) body.billingState = null;
					if (body.billingZip) body.billingZip = null;
					if (body.person) body.person = null;
					
					response.body = JSON.stringify(body)
				}

				// make sure you return the modified response
				return response
			},
		},
		browser: {
			urlSanitizer: url => {
				let sanitizedUrl = url;
	
				// redact the value of the query parameter secret_key
				sanitizedUrl = sanitizedUrl.replace(/token=([^&]*)/, 'token=**redacted**');
	
				// make sure you return the sanitized URL string
				return sanitizedUrl;
			},
		},
	});
}